import { FileTypes } from '../../utils/file_type';
import { Icon, IconDictionary } from '../icon';
import { Illustration } from '../illustration';

interface AttachmentPreviewProps {
	fileType?: FileTypes;
	preview?: string | JSX.Element;
	icon?: keyof IconDictionary;
}

export function AttachmentPreview({ fileType, preview, icon }: AttachmentPreviewProps): JSX.Element {
	let background = false;
	let previewNode;

	if ((fileType === FileTypes.Image && typeof preview === 'string') || typeof preview === 'string') {
		previewNode = <img className='cellula-attachment__preview-image' src={preview} alt='' />;
	} else if (fileType !== undefined) {
		switch (fileType) {
			case FileTypes.Image:
				previewNode = <Illustration type='fileImage' />;
				break;
			case FileTypes.Doc:
				previewNode = <Illustration type='fileWord' />;
				break;
			case FileTypes.Pdf:
				previewNode = <Illustration type='filePdf' />;
				break;
			case FileTypes.Xslx:
				previewNode = <Illustration type='fileExcel' />;
				break;
			case FileTypes.Video:
				previewNode = <Illustration type='fileVideo' />;
				break;
			default:
				previewNode = <Illustration type='fileOtherFormat' />;
		}
	} else if (preview) {
		previewNode = preview;
	} else if (icon) {
		background = true;
		previewNode = <Icon type={icon} size='medium' />;
	} else {
		return <></>;
	}

	return (
		<div className='cellula-attachment__preview-inner' data-background={background || undefined}>
			{previewNode}
		</div>
	);
}
